import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { CollaborateurService } from "../../services/collaborateur.service";
import { CollaborateurPayload } from "../../models/collaborateur";
import { Utils } from "src/app/shared/utils/utils";

declare let swal: any;

@Component({
  selector: "app-form-collaborateur",
  templateUrl: "./form-collaborateur.component.html",
  styleUrls: ["./form-collaborateur.component.css"],
})
export class FormCollaborateurComponent implements OnInit {

  form: FormGroup;
  busy: Subscription;
  collaborateurId: number | null = null;
  parentId: number | null = null;
  isEditMode: boolean = false;
  parentCollaborateur: any = null;

  constructor(
    private fb: FormBuilder,
    private collaborateurService: CollaborateurService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.initForm();

    // Récupère le parent_id depuis les queryParams (mode ajout)
    this.route.queryParams.subscribe(params => {
      if (params['parent_id']) {
        this.parentId = +params['parent_id'];
        this.form.patchValue({ parent_id: this.parentId });

        // Charger les infos du collaborateur parent
        this.collaborateurService.getById(this.parentId).subscribe(
          (data: any) => {
            this.parentCollaborateur = data;
          }
        );
      }
    });

    // Récupère l'id depuis les params (mode edit)
    this.collaborateurId = this.route.snapshot.params["id"]
      ? +this.route.snapshot.params["id"]
      : null;

    if (this.collaborateurId) {
      this.isEditMode = true;
      this.loadCollaborateur(this.collaborateurId);
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      prenom:    ["", Validators.required],
      nom:       [""],
      email:     ["", Validators.email],
      poste:     [""],
      parent_id: [null],
    });
  }

  loadCollaborateur(id: number): void {
    this.busy = this.collaborateurService.getById(id).subscribe(
      (data: any) => {
        this.parentId = data.parent_id;
        this.form.patchValue({
          prenom:    data.prenom,
          nom:       data.nom,
          email:     data.email,
          poste:     data.poste,
          parent_id: data.parent_id,
        });

        // Charger les infos du collaborateur parent
        if (data.parent_id) {
          this.collaborateurService.getById(data.parent_id).subscribe(
            (parent: any) => {
              this.parentCollaborateur = parent;
            }
          );
        }
      },
      () => {
        Utils.sweetAlert("error", "Erreur", "Erreur lors du chargement du sous-collaborateur");
      }
    );
  }

  onSubmit(): void {
    if (this.form.invalid) return;

    const payload: CollaborateurPayload = this.form.value;

    if (this.isEditMode) {
      this.busy = this.collaborateurService.update(this.collaborateurId, payload).subscribe(
        () => {
          Utils.sweetAlert("success", "Succès", "Sous-collaborateur modifié avec succès");
          this.router.navigate(["/collaborateurs"]);
        },
        () => {
          Utils.sweetAlert("error", "Erreur", "Erreur lors de la modification");
        }
      );
    } else {
      this.busy = this.collaborateurService.create(payload).subscribe(
        () => {
          Utils.sweetAlert("success", "Succès", "Sous-collaborateur ajouté avec succès");
          this.router.navigate(["/collaborateurs"]);
        },
        () => {
          Utils.sweetAlert("error", "Erreur", "Erreur lors de l'ajout");
        }
      );
    }
  }

  goBack(): void {
    this.router.navigate(["/collaborateurs"]);
  }
}